const exampleTheme = {
	ltr: 'ltr',
	rtl: 'rtl',
	placeholder: 'editor-placeholder',
	paragraph: 'editor-paragraph',
};

export default exampleTheme;
